import type { ConvexVueTelemetry } from "@shopexperts/convex-vue";

type CaptureError = NonNullable<ConvexVueTelemetry["error"]>;

export function getApiAuthErrorStatus(error: unknown): number | null {
  if (!error || typeof error !== "object") return null;

  const maybeStatus = (error as { status?: unknown }).status;
  if (typeof maybeStatus === "number") return maybeStatus;

  const maybeResponse = (error as { response?: { status?: unknown } }).response;
  return typeof maybeResponse?.status === "number" ? maybeResponse.status : null;
}

export function isConfirmedInvalidApiAuthError(error: unknown): boolean {
  const status = getApiAuthErrorStatus(error);
  return status === 401 || status === 419;
}

export async function verifyApiAuthForConvex({
  checkApiAuth,
  captureError,
}: {
  checkApiAuth: () => Promise<unknown>;
  captureError: CaptureError;
}): Promise<boolean> {
  try {
    await checkApiAuth();
    return true;
  } catch (error) {
    const status = getApiAuthErrorStatus(error);

    if (isConfirmedInvalidApiAuthError(error)) {
      captureError(error, {
        operation: "convex_auth.api_auth_invalid",
        level: "warning",
        extra: { status },
      });
      return false;
    }

    captureError(error, {
      operation: "convex_auth.api_auth_check_failed",
      level: "warning",
      extra: { status },
    });
    throw error;
  }
}
